import React from "react";
import { HelpCircle } from "lucide-react";
import { openTutorial } from "@/components/TutorialOverlay";

/**
 * Small `?` button that re-opens the tutorial at a specific step.
 * Use next to page titles or key sections to offer inline help.
 */
export function HelpIcon({ step = 0, label = "Show help", className = "" }) {
  return (
    <button
      type="button"
      onClick={() => openTutorial(step)}
      aria-label={label}
      title={label}
      className={`inline-flex items-center justify-center w-6 h-6 rounded-full text-[#71717A] hover:text-[#0F8F4F] hover:bg-[#0F8F4F]/10 transition-colors ${className}`}
      data-testid={`help-icon-step-${step}`}
    >
      <HelpCircle className="w-4 h-4" strokeWidth={1.8} />
    </button>
  );
}
